import { ReactComponent as PasswordSVG } from 'assets/images/icons/password.svg';
import { ReactComponent as QuestionSVG } from 'assets/images/icons/question.svg';
import { ReactComponent as TagSVG } from 'assets/images/icons/tag.svg';
import { ReactComponent as TestSVG } from 'assets/images/icons/test.svg';
import { ReactComponent as CartSVG } from 'assets/images/icons/shopping-cart.svg';
import { ReactComponent as UsersSVG } from 'assets/images/icons/followers.svg';
import { ReactComponent as SettingsSVG } from 'assets/images/icons/Settings.svg';
import { ReactComponent as ClockSVG } from 'assets/images/icons/clock.svg';
import { ReactComponent as Link } from 'assets/images/icons/Link.svg';
import { ReactComponent as PencilWriting } from 'assets/images/icons/pencil-writing.svg';
import { ReactComponent as Calendar } from 'assets/images/icons/calendar.svg';
import { ReactComponent as Group } from 'assets/images/icons/Group.svg';
import { ReactComponent as VectorIcon } from 'assets/images/icons/Vector.svg';
import { ReactComponent as BinSVGIcon } from 'assets/images/icons/Bin.svg';
import { ReactComponent as ResetVGIcon } from 'assets/images/icons/Reset.svg';
import { ReactComponent as PasswordReseat } from 'assets/images/icons/PasswordReset.svg';
import { ReactComponent as PencilSVGIcon } from 'assets/images/icons/Pencil-Writing-Grey.svg';
import { ReactComponent as BadgeSvgIcon } from 'assets/images/icons/Badge.svg';
import { ReactComponent as RedBinIcon } from 'assets/images/icons/RedBin.svg';
import { ReactComponent as NotificationSVGIcon } from 'assets/images/icons/notification.svg';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as ChannelLinkSVG } from 'assets/images/icons/ChannelLink.svg';

export const PasswordIcon = () => (
    <SvgIcon>
        <PasswordSVG />
    </SvgIcon>
);

export const QuestionIcon = () => (
    <SvgIcon>
        <QuestionSVG />
    </SvgIcon>
);
export const BinIcon = () => <BinSVGIcon />;
export const PasswordReseatIcon = () => <PasswordReseat />;
export const ResetIcon = () => <ResetVGIcon />;
export const BadgeIcon = () => <BadgeSvgIcon />;
export const RedIcon = () => <RedBinIcon />;
export const PencilWritingGreyIcon = () => <PencilSVGIcon />;
export const TagIcon = () => (
    <SvgIcon>
        <TagSVG />
    </SvgIcon>
);

export const TestIcon = () => (
    <SvgIcon>
        <TestSVG />
    </SvgIcon>
);
export const NotificationIcon = () => (
    <SvgIcon>
        <NotificationSVGIcon />
    </SvgIcon>
);

export const ShoppingCartIcon = () => (
    <SvgIcon>
        <CartSVG />
    </SvgIcon>
);

export const UsersIcon = () => (
    <SvgIcon>
        <UsersSVG />
    </SvgIcon>
);
export const GroupIcon = (props: SvgIconProps) => (
    <SvgIcon>
        <Group />
    </SvgIcon>
);
export const Vector = (props: SvgIconProps) => <VectorIcon />;

export const SettingsIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <SettingsSVG />
    </SvgIcon>
);
export const SyncIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <ClockSVG />
    </SvgIcon>
);
export const LinkIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <Link />
    </SvgIcon>
);
export const PencilWritingIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <PencilWriting />
    </SvgIcon>
);
export const CalendarIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <Calendar />
    </SvgIcon>
);
export const ChannelLinkIcon = () => (
    <SvgIcon>
        <ChannelLinkSVG />
    </SvgIcon>
);
export const ReportIcon = () => (
    <SvgIcon>
        <TestSVG />
    </SvgIcon>
);
export default PasswordIcon;
